import { useDispatch } from "react-redux";
import {
  openAddressModal,
  closeAddressModal,
  updateAddressModal,
  openInvalidAddressModal,
  closeInvalidAddressModal,
  openVerifyAddressModal,
  closeVerifyAddressModal,
} from "../../reducers/layoutReducer";
import { useAddressModalState } from "../../reducers/layoutReducer/selectors";

const ACTION_MAP = {
  addEdit: {
    open: openAddressModal,
    close: closeAddressModal,
    update: updateAddressModal,
  },
  invalid: {
    open: openInvalidAddressModal,
    close: closeInvalidAddressModal,
  },
  verify: {
    open: openVerifyAddressModal,
    close: closeVerifyAddressModal,
  },
};

/**
 * Hook for managing address modals through Redux state.
 *
 * @param {string} modalType - Type of modal: 'addEdit', 'invalid', or 'verify'
 * @returns {Object} Modal controls and state
 * @returns {boolean} isOpen - Whether the modal is open
 * @returns {Object} modalState - Current modal state from Redux
 * @returns {Function} open - Opens the modal with given config
 * @returns {Function} close - Closes the modal
 * @returns {Function} [update] - Updates modal state (only for addEdit modal)
 */
export const useAddressModal = (modalType) => {
  const dispatch = useDispatch();
  const modalState = useAddressModalState(modalType);
  const actions = ACTION_MAP[modalType];

  const isOpen = modalState.show;

  const open = (config = {}) => {
    dispatch(actions.open(config));
  };

  const close = () => {
    dispatch(actions.close());
  };

  const update = actions.update
    ? (updates) => {
        dispatch(actions.update(updates));
      }
    : undefined;

  return {
    isOpen,
    modalState,
    open,
    close,
    ...(update && { update }),
  };
};

export default useAddressModal;
